import { render, staticRenderFns } from "./wardContactSignUp.vue?vue&type=template&id=06ab7f24&scoped=true&"
import script from "./wardContactSignUp.vue?vue&type=script&lang=js&"
export * from "./wardContactSignUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ab7f24",
  null
  
)

export default component.exports